import React, { useMemo } from "react";
import IconActionContextRow from "./IconActionContextRow";

const DEFAULT_ACTION_ORDER = [
  "inspect",
  "reparent",
  "addNew",
  "add",
  "actuator",
  "duplicate",
  "delete",
  "clearScene",
];

const buildOrderIndex = (order) => new Map(order.map((key, index) => [key, index]));

const getActionOrderIndex = (orderIndex, key) => {
  if (key === "clearScene") return Number.POSITIVE_INFINITY;
  return orderIndex.has(key) ? orderIndex.get(key) : Number.MAX_SAFE_INTEGER;
};

const OrderedIconActionContextRow = ({
  actions = [],
  actionOrder = DEFAULT_ACTION_ORDER,
  ...props
}) => {
  const orderedActions = useMemo(() => {
    const orderIndex = buildOrderIndex(actionOrder);
    return [...actions].sort((left, right) => {
      const leftIndex = getActionOrderIndex(orderIndex, left?.key);
      const rightIndex = getActionOrderIndex(orderIndex, right?.key);
      if (leftIndex !== rightIndex) return leftIndex - rightIndex;
      return 0;
    });
  }, [actions, actionOrder]);

  return <IconActionContextRow actions={orderedActions} {...props} />;
};

export default OrderedIconActionContextRow;
